var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPieChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.63 1.37l.08.02a10.76 10.76 0 018.92 8.98c.06.38.13.8-.04 1.25-.13.36-.43.7-.77.9-.23.14-.47.19-.7.21-.2.02-.44.02-.7.02h-5.25c-.53 0-.98 0-1.34-.03-.38-.03-.74-.1-1.08-.27a2.75 2.75 0 01-1.2-1.2c-.17-.34-.24-.7-.27-1.08-.03-.36-.03-.8-.03-1.34V3.57c0-.25 0-.49.02-.69.02-.23.07-.47.21-.7.2-.34.54-.64.9-.77.44-.17.87-.1 1.25-.04zm-.72 1.44l-.02.01a.4.4 0 00-.1.08v.02l-.01.01-.02.1-.01.57v5.2c0 .57 0 .96.02 1.25.03.29.07.43.12.52.12.23.3.42.54.54.1.05.23.1.52.12.3.02.68.02 1.25.02h5.2a6.6 6.6 0 00.68-.03l.02-.02a.41.41 0 00.08-.1l.01-.01v-.1A9.26 9.26 0 0013 2.8l-.08.02zm-3.2-.58c.13.4-.09.82-.49.94a9.25 9.25 0 1011.6 11.6.75.75 0 111.44.45A10.75 10.75 0 118.78 1.74c.39-.12.81.1.94.5z"
  })));
}
export default SvgPieChart;